import { useState, useCallback, useEffect } from "react";
import financialTransactionService from "../services/FinancialTransactionService";

const useFinancialTransactions = (fixedType = null) => {
  const [transactions, setTransactions] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [filters, setFilters] = useState({
    From: "",
    To: "",
    TransactionType: fixedType || "",
    Category: "",
    SearchTerm: "",
    PageIndex: 1,
    PageSize: 10,
  });

  const fetchTransactions = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const params = { ...filters };
      if (fixedType) params.TransactionType = fixedType;

      const res = await financialTransactionService.getAll(params);

      if (res) {
        setTransactions(res.data || []);
        setTotalCount(res.totalCount || 0);
        setTotalPages(res.totalPages || 1);
      } else {
        setTransactions([]);
      }
    } catch (err) {
      setError("حدث خطأ أثناء جلب البيانات المالية");
    } finally {
      setLoading(false);
    }
  }, [filters, fixedType]);

  useEffect(() => {
    fetchTransactions();
  }, [fetchTransactions]);

  const createTransaction = async (payload) => {
    setError(null);
    const body = fixedType ? { ...payload, transactionType: fixedType } : payload;
    try {
      const res = await financialTransactionService.create(body, setError);
      await fetchTransactions();
      return res;
    } catch (err) {
      throw err; // postData بيتكفل بعمل setError جواه بالفعل
    }
  };

  const updateTransaction = async (id, payload) => {
    setError(null);
    const body = fixedType ? { ...payload, transactionType: fixedType } : payload;
    try {
      const res = await financialTransactionService.update(id, body);
      await fetchTransactions();
      return res;
    } catch (err) {
      setError("حدث خطأ أثناء تحديث المعاملة");
      throw err;
    }
  };

  const deleteTransaction = async (id) => {
    setError(null);
    try {
      const res = await financialTransactionService.remove(id);
      await fetchTransactions();
      return res;
    } catch (err) {
      setError("حدث خطأ أثناء حذف المعاملة");
      throw err;
    }
  };

  return {
    transactions,
    totalCount,
    totalPages,
    loading,
    error,
    filters,
    setFilters,
    fetchTransactions,
    createTransaction,
    updateTransaction,
    deleteTransaction,
  };
};

export default useFinancialTransactions;